// Real route registry — resolve pathway keys here instead of inventing URLs.
export const PATHWAY_ROUTES = {
  'career-clarity': '/career-clarity',
  'inner-specializations': '/specializations',
  'future-ready-jobs': '/job-roles',
  'future-ai-agent': '/ai-pathway',
  'ai-risk-check': '/ai-risk-check',
  'build-badges': '/build-badges',
  internships: '/pathways/internships',
  'fresher-launchpad': '/pathways/fresher-launchpad',
  'career-switch-growth': '/pathways/career-switch-growth',
  banking: '/banking',
  'blue-collar': '/blue-collar',
  entrepreneurship: '/ownpath',
  agriculture: '/agriculture',
  'life-skills': '/life-skills',
  'the-ai-shift': '/the-ai-shift',
};

export const resolvePathwayRoute = (key) => PATHWAY_ROUTES[key] || null;
